export interface CurvaRow {
  id: number | string;
  sqp_tsie_quenching: string | number;
  fa_exp: string | number;
  efficiency: string | number;
  fc_calc: string | number;
}
export const initialRowsCurva: CurvaRow[] = [
  {
    id: "new-1",
    sqp_tsie_quenching: 0,
    efficiency: 0,
    fa_exp: 0,
    fc_calc: 0,
  },
  {
    id: "new-2",
    sqp_tsie_quenching: 0,
    efficiency: 0,
    fa_exp: 0,
    fc_calc: 0,
  },
  {
    id: "new-3",
    sqp_tsie_quenching: 0,
    efficiency: 0,
    fa_exp: 0,
    fc_calc: 0,
  },
  {
    id: "new-4",
    sqp_tsie_quenching: 0,
    efficiency: 0,
    fa_exp: 0,
    fc_calc: 0,
  },
  {
    id: "new-5",
    sqp_tsie_quenching: 0,
    efficiency: 0,
    fa_exp: 0,
    fc_calc: 0,
  },
  {
    id: "new-6",
    sqp_tsie_quenching: 0,
    efficiency: 0,
    fa_exp: 0,
    fc_calc: 0,
  },
  {
    id: "new-7",
    sqp_tsie_quenching: 0,
    efficiency: 0,
    fa_exp: 0,
    fc_calc: 0,
  },
  {
    id: "new-8",
    sqp_tsie_quenching: 0,
    efficiency: 0,
    fa_exp: 0,
    fc_calc: 0,
  },
  {
    id: "new-9",
    sqp_tsie_quenching: 0,
    efficiency: 0,
    fa_exp: 0,
    fc_calc: 0,
  },
  {
    id: "new-10",
    sqp_tsie_quenching: 0,
    efficiency: 0,
    fa_exp: 0,
    fc_calc: 0,
  },
];
